/**
 * quote_pipeline — every vertical. GET /quotes/summary/dashboard, as sent.
 * Counts by status and the two values the API sums (sent = pending, accepted).
 */
import { fmtCurrency, parseMoney } from '../../../lib/display-labels';
import { displayValue } from '../../../features/fieldiq-handoff/contracts';
import { queryFailureError, queryLoadFailure } from '../../../lib/load-failure';
import { LoadFailureNotice } from '../../ui/LoadFailureNotice';
import { WidgetFigure, WidgetPanel, WidgetPending } from '../WidgetPanel';
import { parseCount } from '../buildActionAlerts';
import { useOverviewQuoteDash } from '../overviewQueries';
import { useAuth } from '../../../contexts/AuthContext';
import { useTenantCurrency } from '../../../contexts/LocaleContext';
import { ndtTenantQuoteCurrency } from '../../../lib/ndt-quotes';

export default function QuotePipelineWidget() {
  const q = useOverviewQuoteDash();
  const failure = q.data === undefined ? queryLoadFailure(q) : null;
  const d = q.data;
  const n = (v: unknown) => displayValue(parseCount(v));
  // CA$ / US$ for an NDT tenant; null (the bare '$', as before) for every other.
  const cur = ndtTenantQuoteCurrency(useAuth().hasVertical, useTenantCurrency());

  return (
    <WidgetPanel widgetKey="quote_pipeline" eyebrow="Commercial pipeline" title="Quote Pipeline" link={{ label: 'Quotes', to: '/quotes' }}>
      <div className="p-4">
        {failure ? (
          <LoadFailureNotice error={queryFailureError(q)} kind={failure} subject="quotes" className="py-6" />
        ) : !d ? (
          <WidgetPending rows={2} />
        ) : (
          <div className="grid grid-cols-2 gap-x-4 gap-y-5">
            <WidgetFigure testId="quotes-sent" label="Awaiting reply" value={n(d.sent_count)} sub={`${fmtCurrency(parseMoney(d.pending_value), cur)} pending`} />
            <WidgetFigure testId="quotes-accepted" label="Accepted" value={n(d.accepted_count)} sub={fmtCurrency(parseMoney(d.accepted_value), cur)} />
            <WidgetFigure testId="quotes-draft" label="Drafts" value={n(d.draft_count)} />
            <WidgetFigure testId="quotes-expired" label="Expired" value={n(d.expired_count)} sub={`${n(d.declined_count)} declined`} />
          </div>
        )}
      </div>
    </WidgetPanel>
  );
}
